module.exports = __webpack_public_path__ + "img/information.97e83e88.svg";